import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "form",
    "source",
    "details",
    "organization",
    "contactName",
    "email",
    "phone",
    "terms",
    "submitButton"
  ]

  connect() {
    console.log("LeadValidation controller connected")
    
    // Ensure button is disabled on connect
    requestAnimationFrame(() => {
      console.log("Disabling submit button")
      this.submitButtonTarget.disabled = true
      this.validateForm()
    })
    
    // Add input event listeners for real-time validation
    this.element.addEventListener("input", () => {
      console.log("Input event triggered")
      this.validateForm()
    })
  }

  validateForm() {
    const isValid = this.validateRequiredFields() && 
                   this.validateContactInfo() && 
                   this.validateEmail() &&
                   this.validateTerms()
    
    console.log("Form validation result:", isValid, {
      requiredFields: this.validateRequiredFields(),
      contactInfo: this.validateContactInfo(),
      email: this.validateEmail(),
      terms: this.validateTerms()
    })
    
    this.submitButtonTarget.disabled = !isValid
  }

  validateRequiredFields() {
    // Check required fields (source, details, organization, contact name)
    return (
      this.sourceTarget.value !== "" &&
      this.detailsTarget.value.trim() !== "" &&
      this.organizationTarget.value.trim() !== "" &&
      this.contactNameTarget.value.trim() !== ""
    )
  }

  validateContactInfo() {
    // Either email or phone must be filled
    const hasEmail = this.emailTarget.value.trim() !== ""
    const hasPhone = this.phoneTarget.value.trim() !== ""
    return hasEmail || hasPhone
  }

  validateEmail() {
    const email = this.emailTarget.value.trim()
    // If email is empty, it's valid (will use default email)
    if (email === "") return true
    
    // Basic email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  validateTerms() {
    return this.termsTarget.checked
  }
} 